<template>
  <BaseFormGroup
    data-class="base-checkbox-group-field"
    class="base-checkbox-group-field"
    :columnInfo="columnInfo"
    v-bind="$attrs"
  >
    <BaseCheckboxGroup
      v-model="_value"
      :columnInfo="columnInfo"
      :error-visible="errorVisible"
      :options="options"
      :rules="rules"
      :state="state"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </BaseFormGroup>
</template>

<script>
export default {
  name: 'BaseCheckboxGroupField',

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    columnInfo: {
      type: Object,
      required: true,
    },

    /**
     * 選択肢リスト.
     * @type {Array}
     */
    options: {
      type: Array,
      default: () => [],
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    rules: {
      type: Array,
      default: () => [],
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    _value: {
      get() {
        return this.value
      },

      set(v) {
        if (this.value !== v) this.$emit('input', v)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.base-checkbox-group-field {
  margin: 0;
  padding: 0;
}
</style>
